export default __webpack_public_path__ + "static/media/search.6f9c7dde.svg";